
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discover/rainesquare",
      function () {
        return require("private-next-pages/discover/rainesquare/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discover/rainesquare"])
      });
    }
  